import { Value } from "@wojtekmaj/react-daterange-picker/dist/cjs/shared/types";
import { getPdfSizes } from "helpers";
import { t } from "i18next";
import jsPDF from "jspdf";
import moment from "moment";

interface renderTitlesProps {
  pdf: jsPDF;
  bigFontSize: number;
  normalFontSize: number;
  dateRange: Value;
  font: string;
}

export const renderTitleAndDateRange = ({
  pdf,
  bigFontSize,
  normalFontSize,
  dateRange,
  font
}: renderTitlesProps) => {
  const { pageWidth } = getPdfSizes(pdf);

  const reportDateRange = Array.isArray(dateRange)
    ? `${moment(dateRange[0]).format("DD/MM/YYYY")} - ${moment(dateRange[1]).format("DD/MM/YYYY")}`
    : t("All time");

  pdf
    .setFontSize(bigFontSize)
    .setFont(font, "normal", "bold")
    .text(`${t("Drivers deliveries report")}`, pageWidth / 2, 40, {
      align: "center"
    });

  pdf
    .setFontSize(normalFontSize)
    .setFont(font, "normal", "normal")
    .text(`${t("Period")}: ${reportDateRange}`, pageWidth / 2, 60, {
      align: "center"
    });
};
